import {
    ALL_ISTANBUL_EVENTS,
    ALL_ISTANBUL_EVENTS_MAP,
    ALL_MK_EVENTS,
    OVERLAY_MK_EVENTS,
    ALL_DAYS,
    INSTRUMENT_TYPE
} from '../const'
import moment from 'moment'
import Vue from 'vue'

Object.defineProperty(Array.prototype, 'includes', {
    configurable: true,
    writable: true,
    value: function includes(x) {
        return this.indexOf(x) > -1
    }
})

String.prototype.format = function () {
    let content = this
    for (let i = 0; i < arguments.length; i++) {
        const replacement = '{' + i + '}'
        content = content.replace(replacement, arguments[i])
    }
    return content
}

const extractMiriTimelapseNumber = (instrumentEsId, timelapseNumber) => {
    return timelapseNumber
        .split(instrumentEsId + '-')
        .splice(1)
        .join('-')
}

export default {
    remove(array, item) {
        if (array.indexOf(item) >= 0) {
            array.splice(array.indexOf(item), 1)
        }
    },
    filter(list, filter) {
        if (list instanceof Array) {
            return list.filter(filter)
        } else {
            const tempList = {}

            for (const key in list) {
                const item = list[key]

                if (filter(item)) {
                    tempList[key] = item
                }
            }

            return tempList
        }
    },
    random(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
    },
    /* eslint-disable */ // --> OFF
    mobileCheck () {
        let check = false;

        (function (a) {
          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
          }
        })(navigator.userAgent || navigator.vendor || window.opera);

        return check;
    },
    isMobileSize() {
        return window.matchMedia('(max-width: 767px)').matches;
    },
    isUndefined(value) {
        return value === undefined
    },
    truncate(str, wordCount, maxlength, suffix) {
        if (str) {
            const split = str.split(' ')

            let shortened = split.length > wordCount

            let s = split.splice(0, wordCount).join(' ')

            if (maxlength) {
                if (s.length > maxlength) {
                    s = s.substring(0, maxlength)

                    shortened = true
                }
            }

            return s + (shortened ? suffix || '' : '')
        } else {
            return str
        }
    },
    exportAsCSV(data, fields, fileName) {
        const csvText = this.convertToCSV(data, fields)

        this.saveFile(fileName + '.csv', csvText)
    },
    convertToCSV(data, fields) {
        const { parse } = require('json2csv')

        return parse(data, { fields })
    },
    saveFile(filename, text) {
        const element = document.createElement('a')
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
        element.setAttribute('download', filename)
        element.style.display = 'none'

        document.body.appendChild(element)

        element.click()

        document.body.removeChild(element)
    },
    calculateRunIndex(timecode, runsCount, videoLength) {
        if (videoLength > 0) {
            const runIndex = Math.round(timecode / (videoLength / runsCount))

            return runIndex < runsCount ? runIndex : runsCount - 1
        } else {
            return 0
        }
    },
    mapIstanbulEvent(mkEventsMap, { hours = 0 }, hoursSinceFertilization) {

        if (hours > hoursSinceFertilization) {
            return  ''
        }

        let latestEventName = null

        ALL_MK_EVENTS.forEach((eventName)=>{
            const event = mkEventsMap[eventName]||{}
            if (event.value <= hours) {
                latestEventName = eventName.toLowerCase()
            }
        })

        return ALL_ISTANBUL_EVENTS_MAP[latestEventName] || 'N/A'
    },
    getIstanbulEventWithRun(eventName, well) {
        const { runs = [] } = well

        const istanbulEvent = ALL_ISTANBUL_EVENTS.find(event => event.label === eventName)

        let runIndex = null

        if (istanbulEvent) {
            for (let i = 0; i < runs.length; i++) {
                if (runs[i].time <= istanbulEvent.hours) {
                    runIndex = i
                }
            }
        }

        return { runIndex, istanbulEvent }
    },
    getFilterByDayOption(maxDay, titlePrefix= 'D', start=0) {
        const options = []
        for (let i = start; i <= maxDay; i++) {
            const range = `${ALL_DAYS[i].hours}${i===ALL_DAYS.length -1 ?'h+': `-${ALL_DAYS[i+1].hours}h`}`
            options.push({ day: `${titlePrefix} ${i}`,range, value: i })
        }
        return options
    },
    getDayWithRun(daySN, well) {
        const { runs = [] } = well

        const day = ALL_DAYS.find(event => event.label === daySN)

        let runIndex = null

        if (day) {
            runIndex = runs.findIndex(run => run.time > day.hours)
            runIndex = runIndex === -1 ? null : runIndex
        }
        return { runIndex, day }
    },
    filterIstanbulEventsByHoursSinceFertilization(hoursSinceFertilization=0) {
        return ALL_ISTANBUL_EVENTS.filter(event => event.hours <= hoursSinceFertilization)
    },
    filterDaysByHoursSinceFertilization(hoursSinceFertilization, firstRunTime = 0.0) {
        const firstDayNumber = this.getDayNumberFromHours(firstRunTime)
        const lastDayNumber = this.getDayNumberFromHours(hoursSinceFertilization)
        return [...ALL_DAYS].slice(firstDayNumber,lastDayNumber + 1)
    },
    getDayFromHours(hour) {
        const dayNumber = this.getDayNumberFromHours(hour)
        return ALL_DAYS[dayNumber]
    },
    getNextPreviousItem(isForward, items, currentItem) {
        if (!items || !items.length) return

        const index = items.indexOf(currentItem)
        let desiredIndex

        if (isForward) {
            const lastIndex = items.length - 1
            desiredIndex = index + 1 <= lastIndex ? index + 1 : lastIndex
        } else {
            desiredIndex = index > 1 ? index - 1 : 0
        }

        return items[desiredIndex]
    },
    getMkEventsWithImagesForAnnotationOverlay(well) {
        const { inferenceData, runs = [], videoFramesTime } = well

        const { morphokinetics =[] } = inferenceData

        const mkEvents = []

        for (const mkEvent of morphokinetics) {
            if (!OVERLAY_MK_EVENTS.contains(mkEvent.systemName.toLowerCase())) {
                continue
            }

            const runIndex = runs.findIndex(run => run.time === mkEvent.value)

            if (runIndex >= 0 && runIndex < videoFramesTime.length) {
                mkEvents.push({
                    ...mkEvent,
                    imageUrl: this.getImageUrlFromTime(well, videoFramesTime[runIndex])
                })
            }
        }
        return mkEvents
    },
    getLastMkEventWithImage(well) {
        const {inferenceData,runs=[],videoFramesTime} = well
        const { morphokinetics =[] } = inferenceData

        if(morphokinetics.length === 0) return null

        const lastMkEvent = morphokinetics[morphokinetics.length - 1]
        const runIndex= runs.findIndex(run=> run.time === lastMkEvent.value)
        if (runIndex >= 0 && runIndex < videoFramesTime.length) {
            return {
                ...lastMkEvent,
                runIndex,
                imageUrl: this.getImageUrlFromTime(well, videoFramesTime[runIndex])
            }
        }
        return null
    },
    hasEventsForOverlayModal(well) {
        const { morphokinetics =[] } = well.inferenceData
        const events = morphokinetics.filter(mkEvent => OVERLAY_MK_EVENTS.contains(mkEvent.systemName))
        return events.length
    },
    getImageUrlFromTime(well, time, focal=0){
        const { baseImageUrl, lastImageUrl } = well

        let extension = 'jpeg'
        const urlSplits = lastImageUrl.split('.')

        if (urlSplits.length && ['jpeg','jpg','png'].contains(urlSplits[urlSplits.length-1])) {
            extension = urlSplits[urlSplits.length-1]
        }

        return `${baseImageUrl}images/${focal}/${time}.${extension}`
    },
    getDaysSinceFertilization(hoursSinceFertilization){
        return this.getDayNumberFromHours(hoursSinceFertilization)
    },
    getDaysSinceFertilizationRange(daysRange){
        const rangesByDay = {
            0: [0,10],
            1: [11,34],
            2: [34,58],
            3: [59,82],
            4: [60,106],
            5: [107,130],
            6: [131,154],
            7: [132,Number.MAX_SAFE_INTEGER],
        }
        return daysRange.map(dayRange => {
            return rangesByDay  [dayRange.toString()]
        });
    },
    getDayNumberFromHours(hour) {
        switch (true){
            case hour<=10:
                return 0
            case hour<=34:
                return 1
            case hour<=58:
                return 2
            case hour<=82:
                return 3
            case hour<=106:
                return 4
            case hour<=130:
                return 5
            case hour<=154:
                return 6
            default :return 7
        }
    },
    getPastSliderDateRange() {
        const lastMonth = moment().subtract(1, 'months')
        const last3Month = moment().subtract(3, 'months')
        const last6Month = moment().subtract(6, 'months')
        const lastYear = moment().startOf('year').subtract(1, 'years')
        return {
            'Last month': [lastMonth.startOf('month').toDate(), lastMonth.endOf('month').toDate()],
            'Last 3 months': [
                last3Month.startOf('month').toDate(),
                lastMonth.endOf('month').toDate()
            ],
            'Last 6 months': [
                last6Month.startOf('month').toDate(),
                lastMonth.endOf('month').toDate()
            ],
            'Last year': [lastYear.toDate(), lastYear.endOf('year').toDate()]
        }
    },
    getBase64StringFromFile(file){
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(this.removeBasePrefixContentFromBase64(reader.result))
            reader.onerror = error => reject(error)
        })
    },
    removeBasePrefixContentFromBase64(base64){
        const base64Parts = base64.split(',');
        if(base64Parts.length === 2) {
            return base64Parts[1]
        }
        return base64
    },
    monthsToYears(ageInMonths) {
        if (isNaN(ageInMonths)) return ''

        const years = Math.floor(ageInMonths / 12)
        const months = Math.floor(ageInMonths % 12)

        return `${years}.${months}`
    },
    getPatientEsIdLabelByVendor(vendor) {
        const $translate = Vue.$store.getters['locale/translate']
        const { GERI, MIRI , VITRO } = INSTRUMENT_TYPE

        const patientIdLabels = {
            [GERI]: $translate('patient_id'),
            [MIRI]: $translate('patient_code'),
            [VITRO]: $translate('patient')
        }

        return patientIdLabels[vendor]
    },
    getPatientEsIdByVendor(vendor, patient) {
        const { GERI, MIRI , VITRO } = INSTRUMENT_TYPE
        const { esId, identifier1 } = patient

        const patientIds = {
            [GERI]: esId,
            [MIRI]: identifier1,
            [VITRO]: identifier1
        }

        return patientIds[vendor]
    },
    getTreatmentEsIdLabelByVendor(vendor){
        const $translate = Vue.$store.getters['locale/translate']
        const { GERI, MIRI , VITRO } = INSTRUMENT_TYPE

        const treatmentIdLabels = {
            [GERI]: $translate('treatment_id'),
            [MIRI]: $translate('timelapse_#'),
            [VITRO]: $translate('treatment')
        }

        return treatmentIdLabels[vendor]
    },
    getTreatmentEsIdByVendor(vendor, slideEsId, instrumentEsId, treatmentEsId) {
        const { GERI, MIRI , VITRO } = INSTRUMENT_TYPE

        const treatmentEsIdValues = {
            [GERI]: treatmentEsId,
            [MIRI]: extractMiriTimelapseNumber(instrumentEsId, slideEsId),
            [VITRO]: treatmentEsId
        }

        return treatmentEsIdValues[vendor]
    },
    convertMsToHM(milliseconds) {
        const seconds = Math.floor(milliseconds / 1000)
        const minutes = Math.floor(seconds / 60)

        return Math.floor(minutes / 60)
    },
    isNullOrEmptyString(value) {
        return value === null || value === "";
    },
    getFertTypeByWell(well) {
        const firstFrameMs = well.videoFramesTime[0]
        const firstFrameHours = this.convertMsToHM(firstFrameMs)
        return firstFrameHours < 5 ? 'icsi' : 'na'
    }
}
